import { Text } from "components/base/Form";
import { useContext } from "react";
import ProjectContext from "./ProjectContext";

const NotesView = () => {
  const { data, onChange } = useContext(ProjectContext);

  return (
    <div className="card">
      <h5>Notes</h5>

      <div className="mt-2 -mx-[2px]">
        <Text
          placeholder="Write your notes here..."
          value={data.notes}
          onChange={(e) => onChange({ data: { notes: e.target.value } })}
        />
      </div>
    </div>
  );
};

export default NotesView;
